// extracted by mini-css-extract-plugin
export default {"AccountMainPanel":"ChangePasswordPanel_AccountMainPanel__DE+Xw","buttonsPanel":"ChangePasswordPanel_buttonsPanel__Ea0E2"};